import { cn } from '@/lib/cn'
import { ICON_SIZE, ICON_STROKE, Loader2 } from '@/components/icons'

/** A spinner is for a REFETCH — data is on screen and is being refreshed. */
export function Spinner({
  size = 'md',
  className,
  label = 'Loading',
}: {
  size?: keyof typeof ICON_SIZE
  className?: string
  label?: string
}) {
  return (
    <Loader2
      size={ICON_SIZE[size]}
      strokeWidth={ICON_STROKE}
      role="status"
      aria-label={label}
      className={cn('animate-spin text-muted', className)}
    />
  )
}
